/* ============================================================
   EZWN — Effets interactifs v3.1
   reveal · tilt · compteurs · fiche produit (tilt + barre collante
   + cartes animées + carrousel mobile)
   ============================================================ */
(function () {
  'use strict';

  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var prefersReduced = mq('(prefers-reduced-motion: reduce)');
  var finePointer = mq('(hover:hover) and (pointer:fine)');

  function initReveal() {
    if (prefersReduced || !('IntersectionObserver' in window)) return;
    var targets = [];
    var main = document.getElementById('MainContent');
    if (main) {
      Array.prototype.slice.call(main.children).forEach(function (sec, i) {
        if (i === 0) return;
        if (sec.hasAttribute('data-ez-no-reveal')) return;
        sec.classList.add('ez-reveal');
        targets.push(sec);
      });
    }
    document.querySelectorAll('[data-ez-reveal]').forEach(function (el) {
      if (el.classList.contains('ez-reveal')) return;
      el.classList.add('ez-reveal');
      targets.push(el);
    });
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    /* On lit TOUTES les positions d'abord, puis on ecrit les classes ensuite :
       evite d'alterner lecture/ecriture (layout thrashing) qui bloquait le
       scroll au chargement sur mobile. */
    var vh = window.innerHeight;
    var visible = targets.map(function (el) { var r = el.getBoundingClientRect(); return (r.top < vh * 0.9 && r.bottom > 0); });
    targets.forEach(function (el, i) { if (visible[i]) el.classList.add('is-in'); else io.observe(el); });
  }

  function bindTilt(el, max) {
    var raf = null;
    el.addEventListener('pointermove', function (ev) {
      var r = el.getBoundingClientRect();
      var px = (ev.clientX - r.left) / r.width - 0.5;
      var py = (ev.clientY - r.top) / r.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.style.transform = 'perspective(900px) rotateY(' + (px * max).toFixed(2) + 'deg) rotateX(' + (-py * max).toFixed(2) + 'deg)';
      });
    });
    el.addEventListener('pointerleave', function () {
      if (raf) cancelAnimationFrame(raf);
      el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)';
    });
  }
  function initTilt() {
    if (prefersReduced || !finePointer) return;
    document.querySelectorAll('[data-ez-tilt]').forEach(function (el) {
      bindTilt(el, parseFloat(el.getAttribute('data-ez-tilt')) || 10);
    });
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-ez-count]');
    if (!els.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) return;
    function run(el) {
      var raw = (el.textContent || '').trim();
      var m = raw.match(/^([^\d-]*)(-?[\d]+(?:[.,]\d+)?)(.*)$/);
      if (!m) return;
      var pre = m[1], numStr = m[2], suf = m[3];
      var decimals = (numStr.split(/[.,]/)[1] || '').length;
      var sep = numStr.indexOf(',') > -1 ? ',' : '.';
      var target = parseFloat(numStr.replace(',', '.'));
      var dur = 1400, t0 = null;
      function fmt(v) { var s = v.toFixed(decimals); if (sep === ',') s = s.replace('.', ','); return pre + s + suf; }
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased);
        if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initProduct() {
    if (!document.body.classList.contains('template-product')) return;

    var mainImgWrap = document.querySelector('.ezp__main');
    if (mainImgWrap && finePointer && !prefersReduced) {
      mainImgWrap.style.transition = 'transform .18s ease-out';
      mainImgWrap.style.transformStyle = 'preserve-3d';
      bindTilt(mainImgWrap, 6);
    }

    var atc = document.querySelector('.ezp__atc');
    var titleEl = document.querySelector('.ezp__title');
    var priceEl = document.querySelector('.ezp__price');
    if (atc && titleEl) {
      var bar = document.createElement('div');
      bar.className = 'ez-stickybar';
      bar.innerHTML = '<div class="ez-stickybar__in"><span class="ez-stickybar__name"></span><span class="ez-stickybar__spacer"></span><span class="ez-stickybar__price"></span><button type="button" class="ez-stickybar__btn"></button></div>';
      bar.querySelector('.ez-stickybar__name').textContent = titleEl.textContent.trim();
      bar.querySelector('.ez-stickybar__btn').textContent = atc.textContent.trim() || 'Ajouter au panier';
      var barPrice = bar.querySelector('.ez-stickybar__price');
      if (priceEl) barPrice.textContent = priceEl.textContent.trim();
      document.body.appendChild(bar);
      if (priceEl && 'MutationObserver' in window) {
        new MutationObserver(function () { barPrice.textContent = priceEl.textContent.trim(); }).observe(priceEl, { childList: true, characterData: true, subtree: true });
      }
      bar.querySelector('.ez-stickybar__btn').addEventListener('click', function () { atc.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { var above = e.boundingClientRect.top < 0; bar.classList.toggle('is-on', !e.isIntersecting && above); });
        }, { threshold: 0 }).observe(atc);
      }
    }

    /* reveal en cascade des cartes (PC + mobile) */
    function revealStagger(sel, per) {
      var nodes = document.querySelectorAll(sel);
      if (!nodes.length) return;
      if (prefersReduced || !('IntersectionObserver' in window)) { nodes.forEach(function (n) { n.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.15 });
      nodes.forEach(function (el, i) { el.classList.add('ezp-rv'); el.style.transitionDelay = ((i % (per || 3)) * 0.09).toFixed(2) + 's'; io.observe(el); });
    }
    revealStagger('.ezp-card', 3);
    revealStagger('.ezp-tcard', 3);
    revealStagger('.ezp-faq__acc', 1);
  }

  function boot() { initReveal(); initTilt(); initCounters(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
